// user.js
import req from './axios';
import { isMockJs } from './axios'

export const queryUser = () => req('get', isMockJs ? '/users/me' : '/users/me/');

//測試
// export const queryUser = () => req('get', isMockJs ? '/users' : '/users/mfdfh');

export const releaseNote = (sendData) => req('get', isMockJs ? '/releaseNote' : '/release-note/', sendData);

export const logout = () => req('getlogout', isMockJs ? '/users/logout' : '/logout/');





export const dynamicLink = (sendData) => req('head', isMockJs ? sendData : sendData);


//no use
export const surveyRequired = () => req('get', isMockJs ? '/users/survey-required' : '/users/me/survey-required/');

export const survey = (sendData) => req('post', isMockJs ? '/users/survey' : '/survey/', sendData);

export const surveyReset = () => req('put', isMockJs ? '/users/survey-delete' : '/survey-condition/reset/');

